import React from 'react';
import './EmployeeCentralContent.css';
import Cen from '../../assets/images/Central.png';

const EmployeeCentralContent = () => {
  return (
    <section className="ec-page-content-section">
      <div className="container">
        {/* Top Intro Section */}
        <div className="ec-intro-grid">
          <div className="ec-intro-image-container">
            <img 
              src={Cen}
              alt="SAP Employee Central" 
              className="ec-intro-image"
            />
          </div>
          <div className="ec-intro-text">
            <h2 className="ec-intro-title">The Core of Your HR Transformation: SAP SuccessFactors Employee Central</h2>
            <p>
              SAP SuccessFactors Employee Central is the heart of your Human Capital Management (HCM) system. As a flexible, cloud-based Human Resources Information System (HRIS), it is designed to be the central source of truth for all employee data, providing a holistic view of your workforce.
            </p>
          </div>
        </div>

        {/* Features Grid Section */}
        <div className="ec-features-grid">
          <div className="ec-feature-card">
            <h3>Centralized Employee Data</h3>
            <p>
              Consolidate all employee information—from personal details and compensation to job history and performance—into a single, secure, and easily accessible platform. Eliminate data silos and ensure consistency across your organization.
            </p>
          </div>
          <div className="ec-feature-card">
            <h3>Organizational Management</h3>
            <p>
              Visually map and manage your company's structure, positions, and hierarchies. Employee Central allows for dynamic organizational charting, helping you plan for growth, manage reporting lines, and streamline workforce planning.
            </p>
          </div>
          <div className="ec-feature-card">
            <h3>Employee & Manager Self-Service</h3>
            <p>
              Empower your workforce by allowing employees and managers to handle their own HR tasks. From updating personal information and requesting time off to managing team approvals, self-service portals reduce administrative burden and increase efficiency.
            </p>
          </div>
          <div className="ec-feature-card">
            <h3>Global Compliance & Localization</h3>
            <p>
              Operate with confidence across the globe. Employee Central provides built-in localization for over 100 countries, helping you manage diverse legal and regulatory requirements for payroll, benefits, and data privacy.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmployeeCentralContent;
